import { useState, useEffect } from 'react';
import { api, ApiError } from '../lib/api';

export function ResetPassword() {
  const [token, setToken] = useState('');
  const [pw, setPw] = useState('');
  const [confirm, setConfirm] = useState('');
  const [err, setErr] = useState<string | null>(null);
  const [done, setDone] = useState(false);
  const [busy, setBusy] = useState(false);

  useEffect(() => {
    const t = new URLSearchParams(window.location.search).get('token');
    if (t) setToken(t);
  }, []);

  async function onSubmit(e: React.FormEvent) {
    e.preventDefault();
    setErr(null);
    if (pw !== confirm) { setErr('Passwords do not match'); return; }
    if (pw.length < 12) { setErr('Password must be at least 12 characters'); return; }
    setBusy(true);
    try { await api('/api/onboarding/reset-password', { method: 'POST', body: JSON.stringify({ token, password: pw }) }); setDone(true); }
    catch (e) { setErr(e instanceof ApiError ? e.message : 'Reset failed'); }
    finally { setBusy(false); }
  }

  return (
    <div className="min-h-screen flex items-center justify-center p-6">
      <div className="w-full max-w-md">
        <p className="qa-eyebrow mb-3 text-center">Set new password</p>
        <h1 className="qa-h1 text-center mb-6">A fresh <span className="qa-italic-accent">start.</span></h1>
        {done ? (
          <div className="qa-card p-8 text-center">
            <p>Password reset. <a href="/" className="text-rust hover:underline">Sign in now →</a></p>
          </div>
        ) : (
          <form onSubmit={onSubmit} className="qa-card p-8 space-y-5">
            <div>
              <label className="qa-label">New password</label>
              <input type="password" className="qa-input" value={pw} onChange={e => setPw(e.target.value)} required />
              <p className="text-xs text-ink-mute mt-1">12 character minimum</p>
            </div>
            <div>
              <label className="qa-label">Confirm</label>
              <input type="password" className="qa-input" value={confirm} onChange={e => setConfirm(e.target.value)} required />
            </div>
            {err && <div className="qa-badge qa-badge--out w-full justify-center">{err}</div>}
            <button className="btn-primary w-full" disabled={busy || !token}>{busy ? 'Saving…' : 'Set password'}</button>
          </form>
        )}
      </div>
    </div>
  );
}
